import { type ScanDeviceApiDetailQueryMutate, useScanDeviceApiUpsert } from '@hooks/api';
import type { ScanDevice, ScanDeviceDetail, ScanDeviceUpdateRequest } from 'types/api';

export type UseScanDeviceMutate = ScanDeviceApiDetailQueryMutate<ScanDeviceDetail>;

export const useScanDeviceUpdate = useScanDeviceApiUpsert<ScanDevice, ScanDeviceUpdateRequest>(
  '/devices',
);
